export var CardDataHooks;
(function (CardDataHooks) {
    CardDataHooks["CardRoot"] = "card-root";
    CardDataHooks["CardContainer"] = "card-container";
})(CardDataHooks || (CardDataHooks = {}));
export var CardDataKeys;
(function (CardDataKeys) {
    CardDataKeys["Stacked"] = "data-stacked";
})(CardDataKeys || (CardDataKeys = {}));
//# sourceMappingURL=types.js.map